var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7a326c7e7e8e31642d29261480f00c0b78c00199"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["spark-plug@spark-plug"]={id:"7a326c7e7e8e31642d29261480f00c0b78c00199"};
      